"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumberArray = exports.isStringArray = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isStringArray = (options) => options !== undefined && (options.length === 0 || typeof options[0] === 'string');
exports.isStringArray = isStringArray;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isNumberArray = (options) => options !== undefined && (options.length === 0 || typeof options[0] === 'number');
exports.isNumberArray = isNumberArray;
